var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThingGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6223 0C22.552 0 29 6.62741 29 14.4955C29 22.3635 22.562 28.9864 14.6223 28.9864L0 29.0009V14.2463C0 6.38272 6.68359 0.00090625 14.6223 0.00090625V0ZM14.7646 5.51272C11.6308 5.50819 8.72809 7.14578 7.10862 9.82647C5.49913 12.4936 5.43297 15.8159 6.92919 18.5491L5.31516 23.6939L11.1115 22.3962C14.4248 23.8779 18.3189 23.2127 20.9389 20.716C23.5634 18.2383 24.399 14.4003 23.0396 11.0544C21.6712 7.69859 18.3996 5.50819 14.7746 5.51272H14.7646Z",
    fill: "#838383",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThingGrey);
export default __webpack_public_path__ + "static/media/ThingGrey.056055244e234df24f393c772e09ff70.svg";
export { ForwardRef as ReactComponent };